export default "__VITE_ASSET__CqLWg9RJ__"